
import { defineComponent, h, ref } from 'vue';
import { FormInst, FormItemRule } from 'naive-ui';
import { notification, toast } from '../utils/notification.util';
import HoundSelectOption from './shared/HoundSelectOption.vue';
import { SelectOption } from 'naive-ui/lib/select/src/interface';
import BaseNotificationContent from './shared/BaseNotificationContent.vue';
import { http } from '../services';
import { HoundModel, FindAllResponse } from '../../../common';

import { EthersService as eth } from '../services';
import { breedingCurrency } from '@/data/global';

export default defineComponent({
  emits: ['cancel', 'listHound'],
  setup(_, { emit }) {
    const formRef = ref<FormInst | null>(null);
    const cancel = () => {
      emit('cancel');
    };

    const formValue = ref({
      houndId: null,
      breedingFee: null
    });

    const houndOptions = ref<SelectOption[]>();
    const hounds = ref<HoundModel[]>([]);
    const loading = ref<boolean>(false);
    
    http.getOwnHounds({
      limit: null,
      offset: null,
      availableToBreed: false,
      running: false,
      hasLibido: true
    }).then((res: FindAllResponse<HoundModel>) => {
      res.data.forEach(el => {
        hounds.value.push(new HoundModel(el));
      })
      houndOptions.value = res.data.map((h: HoundModel) => ({
        value: h.token_id,
        label: h.name
      }));
    });

    const renderLabel = (option: SelectOption) => {
      const hound = hounds.value.find(h => h.token_id === option.value);
      return h(
        HoundSelectOption,
        {
          hound: hound,
          style: 'height: 5rem',
          showSex: true
        }
      )
    };

    const renderTag = ({ option }) => {
      const hound = hounds.value.find(h => h.token_id === option.value);
      return h(
        HoundSelectOption,
        {
          hound: hound,
          style: 'height: 5rem',
          key: hound.id,
          showSex: true
        }
      );
    };

    const currencyName = eth.currenciesInfo.find(c => c.value === breedingCurrency.value)?.label;

    const listHound = () => {
      formRef.value?.validate(async (errors) => {
        if (errors) {
          toast.error('Invalid values');
          return;
        }
        try {
          loading.value = true;
          const wei = eth.utils.parseEther(String(formValue.value.breedingFee));

          const tx = await eth.hounds.putHoundForBreed(
            String(formValue.value.houndId),
            wei,
            true
          );
          await tx.wait();

          const hound = hounds.value.find(h => h.token_id === formValue.value.houndId);
          
          notification.create({
            title: 'Hound Listed',
            description: `You've successfully listed ${hound.name} on the marketplace.`,
            content: () => h(
              BaseNotificationContent,
              {
                infoElements: [
                  { label: 'Hound', content: hound.name },
                  { label: 'Breeding Fee', content: `${formValue.value.breedingFee} ${currencyName}` }
                ]
              }
            ),
            meta: new Date().toUTCString()
          });
          
          emit('listHound');
          toast.success('Successful listing');
        } catch(err) {
          toast.error('Transaction Failed');
          console.log(err);
        } finally {
          loading.value = false;
          cancel();
        }
      })
    };

    const rules = {
      houndId: {
        trigger: ['blur', 'input'],
        validator: (rule: FormItemRule, value: any) => {
          return new Promise<void>((resolve, reject) => {
            if (value === null) reject(Error('Hound is required'));
            resolve();
          });
        }
      },
      breedingFee: {
        trigger: ['blur', 'input'],
        validator: (rule: FormItemRule, value: any) => {
          return new Promise<void>((resolve, reject) => {
            if (value === null) reject(Error('Breeding Fee is required'));
            if (typeof value !== 'number') reject(Error('Breeding Fee must be a number'));
            if (!(value > 0.001))  reject(Error('Breeding Fee must be greater than 0.001'));
            resolve();
          })
        }
      }
    }

    return {
      formRef,
      formValue,
      cancel,
      listHound,
      rules,
      houndOptions,
      loading,
      eth,
      renderLabel,
      renderTag,
      currencyName
    };
  },
})
